export const getWorkspace = () => localStorage.getItem("avida_workspace") || "";
export const getWorkspaceOrDefault = () => getWorkspace() || "intake";
export const setWorkspace = (w) => localStorage.setItem("avida_workspace", w);
export const isRecruiting = () => getWorkspaceOrDefault() === "recruiting";
export const wsPipeline = () => (isRecruiting() ? "recruiting" : "intake");
export const wsLabel = () => (isRecruiting() ? "Recruiting" : "Clients");
export const displayStage = (n) => (n > 100 ? n - 100 : n);

export const ROLE_TYPES = ["CW/Caregiver", "RN", "Office/Admin", "Data Entry"];
